import { useState }    from 'react';
import {Outlet} from "react-router-dom";
import './style.css';
function Index() {


const [_plan,_setPlan]=useState(0);
// const [_add,_setAdd]=useState(1);
// const [_doc,_setDoc]=useState(2);
// const [_service,_setService]=useState(3);


    return (<div className="container-fluid   vh-100 bg-whitesmoke">                              
                                   <div className="container ">
                                    <div className='d-flex justify-content-around bg-white pt-4 mt-2' style={{height:"80px"}}> 
                                        <div className='text-center w-100 ' style={{border:"none",borderBottom: _plan === 0 ? "3px solid red" : "3px solid gray"}}  onClick={()=>_setPlan(0)}>
<h6>Choose Plan</h6>
                                        </div>
                                        <div className='text-center w-100'style={{border:"none",borderBottom: _plan === 1 ? "3px solid red" : "3px solid gray"}} onClick={()=>_setPlan(1)}>
                                            <h6>Address Details</h6>
                                        </div>
                                        <div className='text-center w-100' style={{border:"none",borderBottom: _plan === 2 ? "3px solid red" : "3px solid gray"}} onClick={()=>_setPlan(2)}>
                                            <h6>Documents</h6>
                                        </div>
                                        <div className='text-center w-100' style={{border:"none",borderBottom: _plan === 3 ? "3px solid red" : "3px solid gray"}} onClick={()=>_setPlan(3)}>
                                            <h6>Service Catelouge</h6>
                                        </div>
                                    </div>
                                    {/* <div className='d-flex justify-content-around bg-white pt-4 ' style={{height:"100px"}}> 
                                        <div className='text-center w-100 ' style={{border:"none",borderBottom: _plan === 0 ? "3px solid red" : "3px solid gray"}}  onClick={()=>_setPlan(0)}>
<h5>Choose Plan</h5>
                                        </div>
                                        <div className='text-center w-100'style={{border:"none",borderBottom: _add === 1 ? "3px solid red" : "3px solid gray"}} onClick={()=>{_setAdd(1);_setPlan(0)}}>
                                            <h5>Address Details</h5>
                                        </div>
                                        <div className='text-center w-100' style={{border:"none",borderBottom: _doc === 1 ? "3px solid red" : "3px solid gray"}} onClick={()=>{_setDoc(1);_setAdd(1);_setPlan(0)}}>
                                            <h5>Documents</h5>
                                        </div>
                                        <div className='text-center w-100' style={{border:"none",borderBottom: _service === 1 ? "3px solid red" : "3px solid gray"}} onClick={()=>{_setService(3);_setDoc(1);_setAdd(1);_setPlan(0)}}>
                                            <h5>Service Catelouge</h5>
                                        </div>
                                    </div> */}
                                   <div>

                                   </div>
                                   </div>
                                    <Outlet/>
    </div>);
}

export default Index;
